import React from 'react';

const logoColors = [
  '#a5b4fc', '#fcd34d', '#d8b4fe',
  '#fdba74', '#e5e7eb', '#6ee7b7',
  '#7dd3fc', '#f9a8d4', '#f0abfc',
];

const ZenGridLogo = ({ className = '' }) => (
  <svg viewBox="0 0 100 100" aria-hidden="true" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect width="100" height="100" rx="16" fill="#f8fafc" />
    {logoColors.map((fill, index) => {
      const column = index % 3;
      const row = Math.floor(index / 3);
      return <rect key={fill} x={8 + column * 30} y={8 + row * 30} width="26" height="26" rx="5" fill={fill} />;
    })}
  </svg>
);

export default ZenGridLogo;